import gql from "graphql-tag";

export const GET_TICKET_SOLD = gql`
  query event_total_tickets_sold($event_id: uuid!) {
    events_by_pk(id: $event_id) {
      total_attendees
      event_attendees_aggregate(where: { is_going: { _eq: true } }) {
        aggregate {
          sum {
            quantity
          }
        }
      }
    }
  }
`;
